window.addEventListener('load', function(){
    // obtain plugin
    var cc = initCookieConsent();

    // run plugin with your configuration
    cc.run({
        current_lang: 'it',
        autoclear_cookies: true,                   // default: false
        page_scripts: true,                        // default: false

        // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        auto_language: 'document',                 // default: null; could also be 'browser' or 'document'
        // autorun: true,                          // default: true
        // force_consent: false,                   // default: false
        // hide_from_bots: false,                  // default: false
        // remove_cookie_tables: false             // default: false
        // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
        // cookie_expiration: 182,                 // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        // cookie_path: '/',                       // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        // revision: 0,                            // default: 0

        onFirstAction: function(user_preferences, cookie){
            // callback triggered only once
        },

        onAccept: function (cookie) {
            // callback triggered on the first accept/reject action, and after each page load
            if(cc.allowedCategory('analytics')){
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
            }
            if(cc.allowedCategory('targeting')){
                fbq('consent', 'grant');
            }
        },

        onChange: function (cookie, changed_preferences) {
            // callback triggered when user changes preferences after consent has already been given
            if(cc.allowedCategory('analytics') === false){
                gtag('consent', 'update', {
                    'ad_storage': 'denied',
                    'analytics_storage': 'denied'
                });
            } else {
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
            }
            if(cc.allowedCategory('targeting') === false){
                fbq('consent', 'revoke');
            } else {
                fbq('consent', 'grant');
            }
        },

        gui_options: {
            consent_modal: {
                layout: 'cloud',               // box/cloud/bar
                position: 'bottom center',     // bottom/middle/top + left/right/center
                transition: 'slide',           // zoom/slide
                swap_buttons: false            // enable to invert buttons
            },
            settings_modal: {
                layout: 'box',                 // box/bar
                // position: 'left',           // left/right
                transition: 'slide'            // zoom/slide
            }
        },

        languages: {
            'en': {
                consent_modal: {
                    title: 'Cookies make things better! ',
                    description: 'We use cookies and first or third party identifiers with your consent and / or our legitimate interest, for the purpose of storing or accessing information on your device, to collect personal user data to develop and improve products, as well as to display and measure advertising. ours and / or third parties and / or personalized content based on your navigation (for example the pages you visit).',
                    primary_btn: {
                        text: 'Accept all',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Settings',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept all',
                    reject_all_btn: 'Reject all',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'Cookie options ',
                            description: 'This website uses essential cookies to ensure its proper functioning and tracking cookies to understand how you interact with it. The latter will be set only with prior consent.'
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are necessary for the site to function and cannot be deactivated in our systems. They are usually only set in response to actions you take that constitute a request for services, such as setting your privacy preferences, logging in or filling out forms. You can set your browser to block or have warnings about these cookies, but as a result some parts of the site will not work. These cookies do not store any personal information.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            }
                        }, {
                            title: 'Performance and Analytics cookies',
                            description: 'These cookies allow us to count visits and traffic sources so that we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information collected by cookies is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you have visited our site.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '^_ga',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: '2 years',
                                    col4: 'HTTP - Register a unique ID used to generate statistical data on how the visitor uses the website',
                                    is_regex: true
                                },
                                {
                                    col1: '_gat',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Used by Google Analytics to limit the frequency of requests',
                                },
                                {
                                    col1: '_gid',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Register a unique ID used to generate statistical data on how the visitor uses the website.',
                                },
                                {
                                    col1: 'collect',
                                    col2: 'google-analytics.com ',
                                    col3: '1 day',
                                    col4: 'Pixel - Used to send data to Google Analytics about the device and user behavior. It tracks the user across devices and marketing channels.',
                                }
                            ]
                        },{
                            title: 'Advertisement and Targeting cookies',
                            description: 'These cookies may be set through our site by our advertising partners. They can be used by these companies to build a profile of your interests and show you relevant ads on other sites. They do not directly store personal information, but are based solely on the identification of your browser and your internet device. If you do not accept these cookies, you will receive less targeted advertising.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '_fbp',
                                    col2: 'superfry.eu',
                                    col3: '3 mesi',
                                    col4: 'HTTP - Used by Facebook to deliver a variety of advertising products such as real-time bids from third party advertisers.',
                                    domain: "superfry.eu"
                                },
                                {
                                    col1: '^bcookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - used by the service of the LinkedIn social network by tracing the use of the integrated services ',
                                    is_regex: true
                                },
                                {
                                    col1: '^bscookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - used by the service of the LinkedIn social network by tracing the use of the integrated services ',
                                },
                                {
                                    col1: '^lidc',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: 'Persistent',
                                    col4: ' HTML - HTTP - used by the service of the LinkedIn social network by tracing the use of the integrated services ',
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 years',
                                    col4: ' HTTP - Used to identify the visitor across visits and devices. This allows the site to present relevant advertising to the visitor. The service is provided by third-party advertising hubs, which facilitate real-time bidding for advertisers.',
                                    is_regex: true
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: 'Session',
                                    col4: ' HTTP - Used to identify the visitor across visits and devices. This allows the site to present relevant advertising to the visitor. The service is provided by third-party advertising hubs, which facilitate real-time bidding for advertisers.',
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Persistent',
                                    col4: 'HTML - Used to identify the visitor through visits and devices. This allows the site to present relevant advertising to the visitor. The service is provided by third-party advertising hubs, which facilitate real-time bidding for advertisers.',
                                },
                                {
                                    col1: '^mautic_referer_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 day',
                                    col4: ' HTTP - Collects information on user behavior on multiple websites. This information is used to optimize the relevance of ati advertising ',
                                },
                                {
                                    col1: 'mtc_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Used to track visitors across multiple websites in order to present relevant advertisements based on visitor preferences',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Used to track visitors across multiple websites in order to present relevant advertisements based on visitor preferences',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: 'Persistent',
                                    col4: ' HTTP - Sets a unique ID for the visitor, which allows third-party advertisers to target advertising relevant to the visitor. This matching service is provided by third-party advertising hubs, which facilitate real-time bidding for advertisers.',
                                },
                            ]
                        }, {
                            title: 'More information',
                            description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/en/privacy-policy">Privacy policy</a>.',
                        }
                    ]
                }
            },
            'fr': {
                consent_modal: {
                    title: 'Les cookies rendent les choses meilleures ! ',
                    description: 'Nous utilisons des cookies et des identifiants propriétaires ou tiers avec votre consentement et / ou notre intérêt légitime, dans le but de stocker ou d\'accéder à des informations sur votre appareil, de collecter des données personnelles de l\'utilisateur pour développer et améliorer les produits, ainsi que pour afficher et mesurer la publicité . les nôtres et/ou des tiers et/ou des contenus personnalisés en fonction de votre navigation (par exemple les pages que vous visitez).',
                    primary_btn: {
                        text: 'Accepter tous',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'paramètres',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Préférences de cookies',
                    save_settings_btn: 'Enregistrer les paramètres',
                    accept_all_btn: 'Accepter tout',
                    reject_all_btn: 'Tout rejeter ',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'Options des cookies',
                            description: 'Ce site web utilise des cookies essentiels pour assurer son bon fonctionnement et des cookies de suivi pour comprendre comment vous interagissez avec lui. Ces derniers ne seront définis qu\'avec un consentement préalable.'
                        }, {
                            title: 'Cookies strictement nécessaires',
                            description: 'Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés dans nos systèmes. Ils ne sont généralement définis qu\'en réponse à des actions que vous entreprenez et qui constituent une demande de services, comme la définition de vos préférences en matière de confidentialité, la connexion ou le remplissage de formulaires. Vous pouvez configurer votre navigateur pour qu\'il bloque ou soit averti de la présence de ces cookies, mais certaines parties du site ne fonctionneront alors pas. Ces cookies ne stockent pas d\'informations personnelles.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            }
                        }, {
                            title: 'Cookies de performance et d\'analyse',
                            description: 'Ces cookies nous permettent de compter les visites et les sources de trafic afin de pouvoir mesurer et améliorer les performances de notre site. Ils nous aident à savoir quelles sont les pages les plus et les moins populaires et à voir comment les visiteurs se déplacent sur le site. Toutes les informations recueillies par les cookies sont agrégées et donc anonymes. Si vous n\'autorisez pas ces cookies, nous ne saurons pas quand vous avez visité notre site.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '^_ga',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: '2 years',
                                    col4: 'HTTP - enregistrer un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site web',
                                    is_regex: true
                                },
                                {
                                    col1: '_gat',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Utilisé par Google Analytics pour limiter la fréquence des demandes.',
                                },
                                {
                                    col1: '_gid',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Enregistrer un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site web.',
                                },
                                {
                                    col1: 'collect',
                                    col2: 'google-analytics.com ',
                                    col3: '1 day',
                                    col4: 'Pixel - Utilisé pour envoyer des données à Google Analytics sur l\'appareil et le comportement de l\'utilisateur. Il suit l\'utilisateur à travers les appareils et les canaux de marketing.',
                                }
                            ]
                        },{
                            title: 'Cookies de publicité et de ciblage',
                            description: 'Ces cookies peuvent être placés sur notre site par nos partenaires publicitaires. Ils peuvent être utilisés par ces sociétés pour établir un profil de vos intérêts et vous montrer des publicités pertinentes sur d\'autres sites. Ils ne stockent pas directement des informations personnelles, mais sont basés uniquement sur l\'identification de votre navigateur et de votre appareil internet. Si vous n\'acceptez pas ces cookies, vous recevrez des publicités moins ciblées.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '_fbp',
                                    col2: 'superfry.eu',
                                    col3: '3 mesi',
                                    col4: 'HTTP - Utilisé par Facebook pour fournir une variété de produits publicitaires tels que des enchères en temps réel d\'annonceurs tiers.',
                                    domain: "superfry.eu"
                                },
                                {
                                    col1: '^bcookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - utilisé par le service du réseau social LinkedIn en traçant l\'utilisation des services intégrés ',
                                    is_regex: true
                                },
                                {
                                    col1: '^bscookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - utilisé par le service du réseau social LinkedIn en traçant l\'utilisation des services intégrés ',
                                },
                                {
                                    col1: '^lidc',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: 'Persistent',
                                    col4: ' HTML - HTTP - utilisé par le service du réseau social LinkedIn en traçant l\'utilisation des services intégrés ',
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 years',
                                    col4: ' HTTP - Utilisé pour identifier le visiteur à travers les visites et les appareils. Cela permet au site de présenter des publicités pertinentes au visiteur. Ce service est fourni par des plateformes publicitaires tierces, qui facilitent les enchères en temps réel pour les annonceurs.',
                                    is_regex: true
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Utilisé pour identifier le visiteur à travers les visites et les appareils. Cela permet au site de présenter des publicités pertinentes au visiteur. Ce service est fourni par des plateformes publicitaires tierces, qui facilitent les enchères en temps réel pour les annonceurs.',
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Persistent',
                                    col4: 'HTML - Utilisé pour identifier le visiteur à travers les visites et les appareils. Cela permet au site de présenter des publicités pertinentes au visiteur. Ce service est fourni par des plateformes publicitaires tierces, qui facilitent les enchères en temps réel pour les annonceurs.',
                                },
                                {
                                    col1: '^mautic_referer_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 day',
                                    col4: ' HTTP - Collecte des informations sur le comportement des utilisateurs sur plusieurs sites web. Ces informations sont utilisées pour optimiser la pertinence de la publicité ati. ',
                                },
                                {
                                    col1: 'mtc_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Utilisé pour suivre les visiteurs sur plusieurs sites web afin de présenter des publicités pertinentes en fonction des préférences des visiteurs.',
                                },
                                {
                                    col1: 'mtc_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Utilisé pour suivre les visiteurs sur plusieurs sites web afin de présenter des publicités pertinentes en fonction des préférences des visiteurs.',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Utilisé pour suivre les visiteurs sur plusieurs sites web afin de présenter des publicités pertinentes en fonction des préférences des visiteurs.',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: 'Persistent',
                                    col4: ' HTTP - Définit un identifiant unique pour le visiteur, ce qui permet aux annonceurs tiers de cibler des publicités pertinentes pour le visiteur. Ce service de correspondance est fourni par des plateformes publicitaires tierces, qui facilitent les enchères en temps réel pour les annonceurs.',
                                },
                            ]
                        }, {
                            title: 'Pour plus d\'informations',
                            description: 'Pour toute question relative à notre politique en matière de cookies et à vos choix, veuillez vous adresser à <a class="cc-link" href="/fr/privacy-policy">Privacy policy</a>.',
                        }
                    ]
                }
            },
            'es': {
                consent_modal: {
                    title: 'I Cookies mejoran las cosas. ',
                    description: 'Utilizamos cookies e identificadores de primera o tercera parte con su consentimiento y/o nuestro interés legítimo, con la finalidad de almacenar o acceder a la información de su dispositivo, para recopilar datos personales de los usuarios para desarrollar y mejorar los productos, así como para mostrar y medir la publicidad. nuestra y/o de terceros y/o contenidos personalizados basados en su navegación (por ejemplo las páginas que visita).',
                    primary_btn: {
                        text: 'Acepta todos',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'configuraciones',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Preferencias de las cookies',
                    save_settings_btn: 'Guardar ajustes',
                    accept_all_btn: 'Aceptar todo',
                    reject_all_btn: 'Rechazar todo',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'Opciones de cookies ',
                            description: 'Este sitio web utiliza cookies esenciales para garantizar su correcto funcionamiento y cookies de seguimiento para entender cómo interactúa usted con él. Estas últimas solo se instalarán con el consentimiento previo.'
                        }, {
                            title: 'Cookies estrictamente necesarias',
                            description: 'Estas cookies son necesarias para que el sitio funcione y no pueden desactivarse en nuestros sistemas. Por lo general, sólo se instalan en respuesta a acciones que usted realiza y que constituyen una solicitud de servicios, como la configuración de sus preferencias de privacidad, el inicio de sesión o la cumplimentación de formularios. Puede configurar su navegador para que bloquee o reciba advertencias sobre estas cookies, pero como resultado algunas partes del sitio no funcionarán. Estas cookies no almacenan ninguna información personal.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            }
                        }, {
                            title: 'Cookies de rendimiento y analíticas',
                            description: 'Estas cookies nos permiten contar las visitas y las fuentes de tráfico para poder medir y mejorar el rendimiento de nuestro sitio. Nos ayudan a saber qué páginas son las más y las menos populares y a ver cómo se mueven los visitantes por el sitio. Toda la información recogida por las cookies es agregada y, por tanto, anónima. Si no permite estas cookies, no sabremos cuándo ha visitado nuestro sitio.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '^_ga',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: '2 years',
                                    col4: 'HTTP - Registrar una identificación única utilizada para generar datos estadísticos sobre el uso que el visitante hace del sitio web',
                                    is_regex: true
                                },
                                {
                                    col1: '_gat',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Utilizado por Google Analytics para limitar la frecuencia de las solicitudes',
                                },
                                {
                                    col1: '_gid',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Registrar una identificación única utilizada para generar datos estadísticos sobre el uso que el visitante hace del sitio web.',
                                },
                                {
                                    col1: 'collect',
                                    col2: 'google-analytics.com ',
                                    col3: '1 day',
                                    col4: 'Pixel - Se utiliza para enviar datos a Google Analytics sobre el dispositivo y el comportamiento del usuario. Realiza un seguimiento del usuario en todos los dispositivos y canales de marketing.',
                                }
                            ]
                        },{
                            title: 'Cookies de publicidad y segmentación',
                            description: 'Estas cookies pueden ser instaladas en nuestro sitio por nuestros socios publicitarios. Pueden ser utilizadas por estas empresas para construir un perfil de sus intereses y mostrarle anuncios relevantes en otros sitios. No almacenan directamente información personal, sino que se basan únicamente en la identificación de su navegador y su dispositivo de Internet. Si no acepta estas cookies, recibirá menos publicidad dirigida.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '_fbp',
                                    col2: 'superfry.eu',
                                    col3: '3 mesi',
                                    col4: 'HTTP: utilizado por Facebook para ofrecer una variedad de productos publicitarios, como ofertas en tiempo real de anunciantes externos.',
                                    domain: "superfry.eu"
                                },
                                {
                                    col1: '^bcookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - utilizado por el servicio de la red social LinkedIn mediante el rastreo del uso de los servicios integrados ',
                                    is_regex: true
                                },
                                {
                                    col1: '^bscookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - utilizado por el servicio de la red social LinkedIn mediante el rastreo del uso de los servicios integrados ',
                                },
                                {
                                    col1: '^lidc',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: 'Persistent',
                                    col4: ' HTML - HTTP - utilizado por el servicio de la red social LinkedIn mediante el rastreo del uso de los servicios integrados ',
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 years',
                                    col4: ' HTTP - Se utiliza para identificar al visitante en todas las visitas y dispositivos. Esto permite que el sitio presente publicidad relevante para el visitante. El servicio es proporcionado por centros de publicidad de terceros, que facilitan las ofertas en tiempo real para los anunciantes.',
                                    is_regex: true
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Se utiliza para identificar al visitante en todas las visitas y dispositivos. Esto permite que el sitio presente publicidad relevante para el visitante. El servicio es proporcionado por centros de publicidad de terceros, que facilitan las ofertas en tiempo real para los anunciantes.',
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Persistent',
                                    col4: 'HTML - Se utiliza para identificar al visitante a través de las visitas y los dispositivos. Esto permite que el sitio presente publicidad relevante para el visitante. El servicio es proporcionado por centros de publicidad de terceros, que facilitan las pujas en tiempo real para los anunciantes.',
                                },
                                {
                                    col1: '^mautic_referer_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 day',
                                    col4: ' HTTP - Recoge información sobre el comportamiento de los usuarios en múltiples sitios web. Esta información se utiliza para optimizar la relevancia de la publicidad ati ',
                                },
                                {
                                    col1: 'mtc_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Se utiliza para rastrear a los visitantes en múltiples sitios web con el fin de presentar anuncios relevantes basados en las preferencias de los visitantes',
                                },
                                {
                                    col1: 'mtc_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Se utiliza para rastrear a los visitantes en múltiples sitios web con el fin de presentar anuncios relevantes basados en las preferencias de los visitantes',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: 'Persistent',
                                    col4: ' HTTP - Establece un identificador único para el visitante, que permite a los anunciantes de terceros dirigir la publicidad relevante para el visitante. Este servicio de concordancia es proporcionado por centros de publicidad de terceros, que facilitan las pujas en tiempo real para los anunciantes.',
                                },
                            ]
                        }, {
                            title: 'Más información',
                            description: 'Para cualquier consulta en relación con nuestra política de cookies y sus opciones, por favor <a class="cc-link" href="/es/privacy-plolicy">Privacy policy</a>.',
                        }
                    ]
                }
            },
            'de': {
                consent_modal: {
                    title: 'Cookies machen die Dinge besser!',
                    description: 'Wir verwenden Cookies und First- oder Third-Party-Identifikatoren mit Ihrer Zustimmung und/oder unserem berechtigten Interesse, um Informationen auf Ihrem Gerät zu speichern oder darauf zuzugreifen, um personenbezogene Benutzerdaten zu sammeln, um Produkte zu entwickeln und zu verbessern sowie um Werbung anzuzeigen und zu messen . unsere und/oder Dritte und/oder personalisierte Inhalte basierend auf Ihrer Navigation (z. B. die von Ihnen besuchten Seiten).',
                    primary_btn: {
                        text: 'Alle akzeptieren',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'settings',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie-Einstellungen',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept all',
                    reject_all_btn: 'Reject all',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: 'Datenschutz-Präferenzzentrum',
                            description: 'Diese Website verwendet wichtige Cookies, um ihr ordnungsgemäßes Funktionieren zu gewährleisten, und Tracking-Cookies, um zu verstehen, wie Sie mit ihr interagieren. Letztere werden nur mit vorheriger Zustimmung gesetzt.'
                        }, {
                            title: 'Streng notwendige Cookies',
                            description: 'Diese Cookies sind für das Funktionieren der Website erforderlich und können in unseren Systemen nicht deaktiviert werden. Sie werden in der Regel nur als Reaktion auf Ihre Handlungen gesetzt, die eine Anfrage nach Dienstleistungen darstellen, wie z. B. die Einstellung Ihrer Datenschutzeinstellungen, das Einloggen oder das Ausfüllen von Formularen. Sie können Ihren Browser so einstellen, dass er diese Cookies blockiert oder Sie vor ihnen warnt, was jedoch zur Folge hat, dass einige Teile der Website nicht funktionieren. Diese Cookies speichern keine persönlichen Informationen.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            }
                        }, {
                            title: 'Leistungs- und Analyse-Cookies',
                            description: 'Diese Cookies ermöglichen es uns, Besuche und Verkehrsquellen zu zählen, so dass wir die Leistung unserer Website messen und verbessern können. Sie helfen uns zu wissen, welche Seiten am beliebtesten und welche am unbeliebtesten sind, und zu sehen, wie sich die Besucher auf der Website bewegen. Alle von den Cookies gesammelten Informationen sind aggregiert und daher anonym. Wenn Sie diese Cookies nicht zulassen, wissen wir nicht, wann Sie unsere Website besucht haben.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '^_ga',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: '2 years',
                                    col4: 'HTTP - Registrierung einer eindeutigen ID, die dazu dient, statistische Daten darüber zu erstellen, wie der Besucher die Website nutzt',
                                    is_regex: true
                                },
                                {
                                    col1: '_gat',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Wird von Google Analytics verwendet, um die Häufigkeit der Anfragen zu begrenzen',
                                },
                                {
                                    col1: '_gid',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Registrieren Sie eine eindeutige ID, die dazu dient, statistische Daten darüber zu erstellen, wie der Besucher die Website nutzt.',
                                },
                                {
                                    col1: 'collect',
                                    col2: 'google-analytics.com ',
                                    col3: '1 day',
                                    col4: 'Pixel - Wird verwendet, um Daten über das Gerät und das Nutzerverhalten an Google Analytics zu senden. Es verfolgt den Nutzer über alle Geräte und Marketingkanäle hinweg.',
                                }
                            ]
                        },{
                            title: 'Cookies für Werbung und Zielgruppenansprache',
                            description: 'Diese Cookies können auf unserer Website von unseren Werbepartnern gesetzt werden. Sie können von diesen Unternehmen verwendet werden, um ein Profil Ihrer Interessen zu erstellen und Ihnen relevante Werbung auf anderen Websites anzuzeigen. Sie speichern nicht direkt persönliche Informationen, sondern basieren ausschließlich auf der Identifizierung Ihres Browsers und Ihres Internetgeräts. Wenn Sie diese Cookies nicht akzeptieren, werden Sie weniger gezielte Werbung erhalten.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '_fbp',
                                    col2: 'superfry.eu',
                                    col3: '3 mesi',
                                    col4: 'HTTP – Wird von Facebook verwendet, um eine Vielzahl von Werbeprodukten bereitzustellen, z. B. Echtzeitgebote von Werbetreibenden Dritter.',
                                    domain: "superfry.eu"
                                },
                                {
                                    col1: '^bcookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - die vom Dienst des sozialen Netzwerks LinkedIn genutzt werden, indem die Nutzung der integrierten Dienste verfolgt wird ',
                                    is_regex: true
                                },
                                {
                                    col1: '^bscookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - die vom Dienst des sozialen Netzwerks LinkedIn genutzt werden, indem die Nutzung der integrierten Dienste verfolgt wird ',
                                },
                                {
                                    col1: '^lidc',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: 'Persistent',
                                    col4: ' HTML - HTTP - die vom Dienst des sozialen Netzwerks LinkedIn genutzt werden, indem die Nutzung der integrierten Dienste verfolgt wird ',
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 years',
                                    col4: ' HTTP - Wird verwendet, um den Besucher über Besuche und Geräte hinweg zu identifizieren. Dies ermöglicht es der Website, dem Besucher relevante Werbung zu präsentieren. Der Dienst wird von Werbeknotenpunkten Dritter bereitgestellt, die Echtzeitgebote für Werbetreibende ermöglichen.',
                                    is_regex: true
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Wird verwendet, um den Besucher über Besuche und Geräte hinweg zu identifizieren. Dies ermöglicht es der Website, dem Besucher relevante Werbung zu präsentieren. Der Dienst wird von Werbeknotenpunkten Dritter bereitgestellt, die Echtzeitgebote für Werbetreibende ermöglichen.',
                                },
                                {
                                    col1: '^mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: 'offcar.mymkt.io',
                                    col4: 'HTML - Wird verwendet, um den Besucher durch Besuche und Geräte zu identifizieren. Dies ermöglicht es der Website, dem Besucher relevante Werbung zu präsentieren. Der Dienst wird von Drittanbietern zur Verfügung gestellt, die Echtzeitgebote für Werbetreibende ermöglichen.',
                                },
                                {
                                    col1: '^mautic_referer_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 day',
                                    col4: ' HTTP - Sammelt Informationen über das Nutzerverhalten auf mehreren Websites. Diese Informationen werden verwendet, um die Relevanz der ati-Werbung zu optimieren ',
                                },
                                {
                                    col1: 'mtc_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Wird verwendet, um Besucher über mehrere Websites hinweg zu verfolgen, um relevante Werbung auf der Grundlage der Besucherpräferenzen zu präsentieren.',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Wird verwendet, um Besucher über mehrere Websites hinweg zu verfolgen, um relevante Werbung auf der Grundlage der Besucherpräferenzen zu präsentieren.',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: 'Persistent',
                                    col4: ' HTTP - Legt eine eindeutige ID für den Besucher fest, die es Drittanbietern ermöglicht, für den Besucher relevante Werbung zu schalten. Dieser Matching-Service wird von Werbeknotenpunkten Dritter bereitgestellt, die Echtzeitgebote für Werbetreibende ermöglichen',
                                },
                            ]
                        }, {
                            title: 'Weitere Informationen',
                            description: 'Bei Fragen zu unserer Politik in Bezug auf Cookies und Ihre Wahlmöglichkeiten wenden Sie sich bitte an <a class="cc-link" href="/de/privacy-policy">Privacy policy</a>.',
                        }
                    ]
                }
            },
            'it': {
                consent_modal: {
                    title: 'I Cookie rendono le cose migliori!',
                    description: 'Utilizziamo cookie e identificatori di prima o terza parte con il tuo consenso e/o nostro interesse legittimo, allo scopo di immagazzinare o accedere alle informazioni sul tuo dispositivo, per raccogliere dati personali degli utenti per sviluppare e migliorare prodotti, nonché per visualizzare e misurare pubblicità  nostra e/o di terzi e/o contenuti personalizzati basati sulla tua navigazione (ad esempio le pagine visitate). ',
                    primary_btn: {
                        text: 'Accetta tutti',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Impostazioni',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                    save_settings_btn: 'Salva le impostazioni',
                    accept_all_btn: 'Accetta tutti',
                    reject_all_btn: 'Rifiuta tutti',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Nome'},
                        {col2: 'Dominio'},
                        {col3: 'Scadenza'},
                        {col4: 'Tipo'}
                    ],
                    blocks: [
                        {
                            title: 'Centro preferenze sulla privacy',
                            description: 'Questo sito Web utilizza cookie essenziali per garantirne il corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. Quest\'ultimo sarÃ  impostato solo previo consenso.'
                        }, {
                            title: 'Cookie strettamente necessari',
                            description: 'Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati  nei nostri sistemi. Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, come l\'impostazione delle preferenze di privacy, l\'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non funzioneranno. Questi cookie non archiviano informazioni personali.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            }
                        }, {
                            title: 'Cookie di prestazione',
                            description: 'Questi cookie ci permettono di contare le visite e fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più e meno popolari e vedere come i visitatori si muovono intorno al sito. Tutte le informazioni raccolte dai cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non sapremo quando hai visitato il nostro sito.',
                            toggle: {
                                value: 'analytics',     // your cookie category
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '^_ga',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: '2 years',
                                    col4: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet',
                                    is_regex: true
                                },
                                {
                                    col1: '_gat',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Utilizzato da Google Analytics per limitare la frequenza delle richieste',
                                },
                                {
                                    col1: '_gid',
                                    col2: 'superfry.eu',
                                    col3: '1 day',
                                    col4: 'HTTP - Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.',
                                },
                                {
                                    col1: 'collect',
                                    col2: 'google-analytics.com ',
                                    col3: '1 day',
                                    col4: 'Pixel- Utilizzato per inviare dati a Google Analytics in merito al dispositivo e al comportamento dell\'utente. Tiene traccia dell\'utente su dispositivi e canali di marketing.',
                                }
                            ]
                        }, {
                            title: 'Cookie per pubblicità  mirata',
                            description: 'Questi cookie possono essere impostati tramite il nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da queste aziende per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti. Non memorizzano direttamente informazioni personali, ma sono basati unicamente sull/individuazione del tuo browser e del tuo dispositivo internet. Se non si accettano questi cookie, riceverai una pubblicità  meno mirata.',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: '_fbp',
                                    col2: 'superfry.eu',
                                    col3: '3 mesi',
                                    col4: 'HTTP - Utilizzato da Facebook per fornire una serie di prodotti pubblicitari come le offerte in tempo reale di terze parti inserzionisti. ',
                                    domain: "superfry.eu"
                                },
                                {
                                    col1: '^bcookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - utilizzato dal servizio di social network LinkedIn per tracciare l\'utilizzo di servizi integrati',
                                    is_regex: true
                                },
                                {
                                    col1: '^bscookie',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: '2 years',
                                    col4: ' HTTP - HTTP - utilizzato dal servizio di social network LinkedIn per tracciare l\'utilizzo di servizi integrati.',
                                },
                                {
                                    col1: '^lidc',       // match all cookies starting with "_ga"
                                    col2: 'linkedin.com',
                                    col3: 'Persistent',
                                    col4: ' HTML - HTTP - utilizzato dal servizio di social network LinkedIn per tracciare l\'utilizzo di servizi integrati.',
                                },
                                {
                                    col1: 'mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 years',
                                    col4: ' HTTP - Utilizzato per identificare il visitatore attraverso le visite e i dispositivi. Ciò consente al sito di presentare pubblicità pertinente al visitatore. Il servizio è fornito da hub pubblicitari di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti.',
                                },
                                {
                                    col1: 'mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Utilizzato per identificare il visitatore attraverso le visite e i dispositivi. Ciò consente al sito di presentare pubblicità pertinente al visitatore. Il servizio è fornito da hub pubblicitari di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti.',
                                },
                                {
                                    col1: 'mautic_device_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Persistent',
                                    col4: 'HTML - Utilizzato per identificare il visitatore attraverso le visite e i dispositivi. Ciò consente al sito di presentare pubblicità pertinente al visitatore. Il servizio è fornito da hub pubblicitari di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti.',
                                },
                                {
                                    col1: 'mautic_referer_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: '1 day',
                                    col4: ' HTTP - Raccoglie in formazioni sul comportamento degli utenti su più siti web. Questa in formazione è utilizzata al fin e di ottimizzare la rilevanza della pubblicità ',
                                },
                                {
                                    col1: 'mtc_id',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Utilizzato per tracciare i visitatori su più siti web, al fine di presentare annunci pubblicitari pertinenti in base alle preferenze del visitatore',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'offcar.mymkt.io',
                                    col3: 'Session',
                                    col4: ' HTTP - Utilizzato per tracciare i visitatori su più siti web, al fine di presentare annunci pubblicitari pertinenti in base alle preferenze del visitatore',
                                },
                                {
                                    col1: 'mtc_sid',       // match all cookies starting with "_ga"
                                    col2: 'superfry.eu',
                                    col3: 'Persistent',
                                    col4: ' HTTP - Imposta un ID univoco per il visitatore, che consente agli in serzionisti di terze parti di in dirizzare pubblicità  pertinente al visitatore. Questo servizio di abbinamento è fornito da hub di pubblicità  di terze parti, che facilitano le offerte in tempo reale per gli inserzionisti.',
                                },
                            ]
                        },
                        {
                            title: 'Maggiori informazioni',
                            description: 'Per maggiori informazioni leggi la nostra <a class="cc-link" href="/privacy-policy">Privacy policy</a>.',
                        }
                    ]
                }
            }
        }
    });
});
